const WORDS = ['Fuerza', 'Disciplina', 'Constancia', 'Tu mejor versión', 'Disfruta el proceso'];

const Row = () => (
    <div className="flex shrink-0 items-center">
        {Array.from({ length: 3 }).map((_, r) =>
            WORDS.map((w, i) => (
                <span key={`${r}-${i}`} className="flex items-center whitespace-nowrap">
                    <span className="font-serif italic font-light text-xl md:text-2xl text-ink/55 px-8 tracking-wide">{w}</span>
                    <span className="text-rose text-sm">✦</span>
                </span>
            ))
        )}
    </div>
);

export const Marquee = () => (
    <div className="border-y border-ink/10 py-5 overflow-hidden bg-white/40" data-testid="editorial-marquee">
        <div className="flex w-max animate-marquee">
            <Row />
            <Row />
        </div>
    </div>
);
